/**
 * OAuth Configuration
 * Provides Google OAuth URL that works in both development and production
 */

import { API_URL } from './api'

/**
 * Get Google OAuth URL
 * @returns {string} Full Google OAuth URL
 */
export const getGoogleOAuthUrl = () => {
  // In production/staging, use the full API URL
  // In development, use relative URL (Vite proxy handles it)
  if (API_URL) {
    return `${API_URL}/api/oauth/google`
  }

  // In development
  return '/api/oauth/google'
}

export default {
  getGoogleOAuthUrl,
}
